import About from "./About";
import "./App.css";
import Footer from "./Footer";
import Hero from "./Hero";
import OtherProjects from "./OtherProjects";
import Projects from "./Projects";
import Skills from "./Skills";

function App() {
  return (
    <div className="app">
      <a
        href="https://drive.google.com/file/d/1E_wVWH_GgQmHlAPxN-A-8fVgMyCl0IHW/view?usp=sharing"
        className="app__resume"
        target="_blank"
        rel="noreferrer"
      >
        Resume
      </a>
      <Hero />
      <About />
      <Skills />
      <Projects />
      <OtherProjects />
      <Footer />
    </div>
  );
}

export default App;
